import { detectCity } from '@/api/cities';

export default defineNuxtRouteMiddleware(async (to) => {
  if (to.name !== 'Partner catalog' || to.params.city) return;
  const city = await detectCity();
  to.params.city = city.slug;
  return navigateTo(to);
});
